<template>
  <loader v-if="loadingProducts" />
  <div v-else>
    <h5>{{ i18n.t('/pdf/categories/categories dealeraccessories label') }}</h5>
    <products-block
      :data-qa="`${quoteNamespace}_dealer-accessories`"
      :products="products"
      :products-categories="categories"
      :selected-products="selectedProducts"
      :products-are-editable="isEditable"
      block-type="DealerAccessories"
      @add-to-selected="addToSelected"
      @remove-from-selected="removeFromSelected"
    />
  </div>
</template>

<script>
import ProductsBlock from '@/components/generic/presentational/organisms/productsBlock/ProductsBlock.vue'
import HandleAccessoryEvents from '@/mixins/handleAccessoryEvents.js'
import AdditionalOrder from '@/mixins/additionalOrder.js'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'
import { mapState } from 'vuex'

export default {
  components: {
    ProductsBlock,
    Loader,
  },
  mixins: [HandleAccessoryEvents, AdditionalOrder],
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      categories: ['DealerAccessories'],
    }
  },
  computed: {
    // Dynamic namespaces aren't supported by mapGetters
    ...mapState({
      state(state) {
        return state[this.quoteNamespace]
      },
      quoteAccessoriesWithCategories(state, getters) {
        return getters[this.quoteNamespace + '/accessoriesWithCategories']
      },
      isEditable(state, getters) {
        return !getters[this.quoteNamespace + '/quoteStatusIsSalesOrder']
      },
      // The accessories module is registered at the root of the store, not under
      // the quote, so it is never reachable through the quote namespace.
      loadingProducts(state, getters) {
        return getters['accessories/loading']
      },
      accessoriesWithCategories(state, getters) {
        return getters['accessories/accessoriesWithCategories']
      },
    }),
    selectedProducts() {
      return this.quoteAccessoriesWithCategories(this.categories)
    },
    products() {
      if (this.additionalQuote) {
        // The optional chain only moved the crash one line down: `undefined.includes`
        // throws just as `undefined.map` would.
        const parentQuoteAccessories =
          this.$store.getters['quote/accessoriesWithCategories'](this.categories)?.map(
            (x) => x.ID
          ) || []
        return this.accessoriesWithCategories(this.categories).filter(
          (x) => !parentQuoteAccessories.includes(x.ID)
        )
      }
      return this.accessoriesWithCategories(this.categories)
    },
  },
}
</script>
